import axios from "axios";

export const getCategories = async (params) => {
    try {
        let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/categories`,{params});
        return data
    } catch (error) {
        return error?.response?.data
    }
}